export default __webpack_public_path__ + "static/media/b01.deaa0520.png";